import React from "react";

// Next 4 open periods + Custom. Picking Custom clears the name and focuses the input.
export const PeriodChips = ({ names, value, onPick, inputId, testPrefix = "period-chip" }) => {
  const isCustom = !!value && !names.includes(value);
  const cls = (on) => `min-h-[36px] rounded-full border px-3 text-xs font-medium transition-colors ${on ? "border-[#007a9e] bg-[#e6f4f8] text-[#00607d]" : "border-[#e5e7eb] text-[#374151] hover:border-[#007a9e] hover:text-[#007a9e]"}`;
  return (
    <div className="mt-2 flex flex-wrap gap-2" data-testid={`${testPrefix}s`}>
      {names.map((n) => (
        <button key={n} type="button" onClick={() => onPick(n)} aria-pressed={value === n}
          data-testid={`${testPrefix}-${n.replace(/\W+/g, "-").toLowerCase()}`} className={cls(value === n)}>{n}</button>
      ))}
      <button type="button" aria-pressed={isCustom} data-testid={`${testPrefix}-custom`} className={cls(isCustom)}
        onClick={() => { onPick(""); document.getElementById(inputId)?.focus(); }}>Custom</button>
    </div>
  );
};

export default PeriodChips;
